import React from 'react';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';
import { AuthenticatedApp } from './components/AuthenticatedApp';
import { CustomerIntakePlaceholder } from './pages/CustomerIntakePlaceholder';
import { WallDisplayPlaceholder } from './pages/WallDisplayPlaceholder';
import DebugPage from './components/DebugPage';
import { installApiAuthFetch } from './services/apiAuthFetch';
import './App.css';

const msalInstance = new PublicClientApplication(msalConfig);
// At module scope, so it is in place before index.tsx's first /api call
// (bootstrapAppSettings) — imports evaluate before index.tsx's body.
installApiAuthFetch(msalInstance);

function App() {
  const pathname = window.location.pathname;

  // Public, unauthenticated routes — mounted BEFORE MsalProvider so they
  // never trigger an AAD redirect or load the staff app shell. The full
  // pages for these are deferred; placeholders explain the status.
  if (pathname.startsWith('/check-in/intake/')) {
    return (
      <div className="App">
        <CustomerIntakePlaceholder />
      </div>
    );
  }
  if (pathname.startsWith('/check-in/wall')) {
    return (
      <div className="App">
        <WallDisplayPlaceholder />
      </div>
    );
  }

  // Check if we're on the debug route. Dev only: it is mounted outside MsalProvider,
  // so in production it would be an unauthenticated page, and its API tester is
  // hard-wired to localhost:7071.
  const isDebugRoute =
    process.env.NODE_ENV !== 'production' &&
    (pathname === '/debug' || window.location.search.includes('debug=true'));

  if (isDebugRoute) {
    return (
      <div className="App">
        <DebugPage />
      </div>
    );
  }

  return (
    <MsalProvider instance={msalInstance}>
      <div className="App">
        <AuthenticatedApp />
      </div>
    </MsalProvider>
  );
}

export default App;